import _ from 'lodash'

/*
 * Takes some of the oddities of touch events and pageX/pageY and translates them to mouse event equivalents
 */
export default function (e) {
  if(!e) {
    return
  }

  var coordSource = e
  if (!_.isNumber(e.pageX) && e.originalEvent) {
    // Prefer touches[0], because in multi-touch pageX may be a different touch
    if (e.originalEvent.touches && e.originalEvent.touches[0] && _.isNumber(e.originalEvent.touches[0].pageX)) {
      coordSource = e.originalEvent.touches[0]
    } else if (_.isNumber(e.originalEvent.pageX)) {
      coordSource = e.originalEvent
    }
  }

  return _.extend({}, e, {
    pageX: coordSource.pageX,
    pageY: coordSource.pageY
  })
}
